import { action, makeObservable, observable } from 'mobx';
import { LaunchData } from '../models';
import { HttpResponse } from '../api';
import { env } from '../environment';
import { RootStore } from '.';

export class SlotHistoryStore {
  public refTokenInfo = new HttpResponse<string | null>(null);;

  rootStore: RootStore;

  isSlotHistoryOpen = false;

  slotType: string = 'lines';
  
  historyUrl: string = '';

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      isSlotHistoryOpen: observable,
      setIsSlotsHistoryOpen: action,

      slotType: observable,
      setSlotType: action.bound,

      historyUrl: observable,
      setHistoryUrl: action.bound
    });
  }

  setIsSlotsHistoryOpen(state: boolean) {
    this.isSlotHistoryOpen = state;
  }
 
  setSlotType(type: string) {
    this.slotType = type;
  }

  public setRefTokenInfo(value: HttpResponse<string | null>): void {
    this.refTokenInfo = value;
  }

  setHistoryUrl(url: string) {
    this.historyUrl = url;
  }

  public generateLaunchUrl(data: LaunchData, slotType: string, token?: HttpResponse<string | null>): string {
    const { currency, currencySymbol, culture, gameId, licenseType } = data;

    const url = new URL(`${env.origin}/slots-history/`);
    url.searchParams.set('currencySymbol', `${decodeURIComponent(currencySymbol)}`);
    if (licenseType) url.searchParams.set('licenseType', `${licenseType}`);
    if (gameId) url.searchParams.set('gameId', `${gameId}`);
    if (token) url.searchParams.set('token', `${token}`);
    url.searchParams.set('currency', `${currency}`);
    url.searchParams.set('culture', `${culture}`);
    url.searchParams.set('slotType', slotType);

    return url.toString();
  }

  public async openSlotsHistory(launchData: LaunchData) {
    if (!launchData) return;

    const url = this.generateLaunchUrl(launchData, this.slotType, this.refTokenInfo);
    
    this.setHistoryUrl(url);
  }

  
  public closeSlotsHistory() {
    this.setIsSlotsHistoryOpen(false);
    this.setHistoryUrl('');
    this.rootStore.postMessageStore.sendMessage({
      name: "slotHistoryClosed",
      payload: null
    });
  }
}
